export const getTherapyOccurrenceRequestStatusLabel = (status) => {
  const map = {
    pending: 'Na cekanju',
    sent: 'Poslato',
    cancelled: 'Otkazano',
  };

  return map[status] || status || '-';
};
